{
  "title": "Confidențialitate și cookies",
  "description": "Folosim cookies pentru a îmbunătăți experiența ta și pentru analiză. Datele tale sunt procesate conform GDPR și sunt stocate în siguranță.",
  "viewDetails": "Detalii despre prelucrarea datelor",
  "acceptAll": "Acceptă toate",
  "acceptEssential": "Doar esențiale",
  "reject": "Refuză",
  "readMore": "Citește",
  "privacyPolicy": "Politica de confidențialitate",
  "essentialTitle": "Cookies esențiale",
  "essentialDesc": "Necesare pentru funcționarea aplicației (autentificare, preferințe, securitate). Aceste cookies nu pot fi dezactivate.",
  "analyticsTitle": "Cookies de analiză",
  "analyticsDesc": "Ne ajută să îmbunătățim aplicația prin analiza comportamentului utilizatorilor. Datele sunt anonimizate și nu sunt partajate cu terțe părți.",
  "changePreferences": "Poți schimba preferințele în setări oricând."
}
